type RenderTableType2Props = {
  table: string[][];
  selectedCells: Set<string>;
  onCellClick: (row: number, col: number) => void;
  isGameStarted: boolean;
};
// Компонент для отображения таблицы типа 2
const RenderTableType2 = ({
  table,
  selectedCells,
  onCellClick,
  isGameStarted,
}: RenderTableType2Props) => {
  const widthCell = table[1].length >9? table[1].length>11?"3vw":"4vw":"5vw";
  return (
    <div
      className="tableS-table--Type2"
      style={{
        gridTemplateColumns: `repeat(${table[0].length}, ${widthCell})`,
      }}
    >
      {table.map((row, rowIndex) =>
        row.map((cell, colIndex) => {
          const key = `${rowIndex}-${colIndex}`;

          return (
            <div
              key={key}
              className={
                "tableS-cell--Type2 " +
                (selectedCells.has(key)
                  ? "tableS-cell-selected"
                  : "")
              }
              onClick={() => isGameStarted && onCellClick(rowIndex, colIndex)}
            >
              {isGameStarted ? cell : "?"}
            </div>
          );
        })
      )}
    </div>
  );
};

export default RenderTableType2;